module.exports = __webpack_public_path__ + "static/index/img/baikal-401.d7508591.jpg";